import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

export function ResendConfirmAsk({ open, onCancel, onAnswer, external }) {
  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent data-testid="resend-confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Inviare di nuovo la conferma al cliente?</AlertDialogTitle>
          <AlertDialogDescription>
            Il tecnico riceve comunque la notifica della modifica. Scegli se mandare al cliente anche un nuovo messaggio WhatsApp di conferma
            {external ? " (partirà solo dopo che il tecnico esterno avrà confermato)" : ""}.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2">
          <Button variant="outline" className="rounded-full" onClick={() => onAnswer(false)} data-testid="resend-confirm-no">No, solo al tecnico</Button>
          <Button className="rounded-full" onClick={() => onAnswer(true)} data-testid="resend-confirm-yes">Sì, invia al cliente</Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
